export const topicList = [
  { "topic": "视觉-语言模型在复杂场景中的推理能力" },
  { "topic": "下一代Transformer替代架构探索" },
  { "topic": "企业知识库构建方法论" },
  { "topic": "LLMOps体系构建实践" },
  { "topic": "分布式Agent系统架构" },
  { "topic": "企业级Skills标准设计" },
  { "topic": "Skills模块化与复用" },
  { "topic": "MCP在企业中的落地实践" },
  { "topic": "MCP生态构建" },
  { "topic": "多模态感知在机器人中的应用" },
  { "topic": "3D空间理解技术演进" },
  { "topic": "强化学习在机器人控制中的应用" },
  { "topic": "具身智能与大模型结合" },
  { "topic": "数据投毒攻击检测方法" },
  { "topic": "AI供应链安全风险" },
  { "topic": "推理型模型（Reasoning Model）能否取代传统LLM" },
  { "topic": "从RLHF到DPO：对齐技术的范式演进" },
  { "topic": "模型量化：性能损失与成本节约的平衡点" },
  { "topic": "企业知识库建设：从0到1的真实挑战" },
  { "topic": "多模型协同：未来系统架构的新常态" },
  { "topic": "企业级AI平台的建设路径" },
  { "topic": "AI工具化 vs 平台化：产品形态之争" },
  { "topic": "复杂任务拆解：Agent的核心难题" },
  { "topic": "Skills体系：Agent落地的关键基础设施" },
  { "topic": "Skills是“能力封装”还是“新一代API”" },
  { "topic": "企业级Skills设计方法论" },
  { "topic": "MCP在企业系统集成中的实践" },
  { "topic": "MCP如何降低Agent开发成本" },
  { "topic": "多模态感知的现实瓶颈" },
  { "topic": "3D空间理解：从视觉到认知" },
  { "topic": "RAG数据泄露：企业AI最大的隐患" },
  { "topic": "Agent权限滥用：自动化时代的新风险" },
  { "topic": "工具调用安全：被忽视的漏洞入口" },
  { "topic": "MCP安全：标准化是否带来新风险" },
  { "topic": "AI可信性的构建路径" },
  { "topic": "AI在能源行业的安全应用" },
  { "topic": "AI在交通系统中的安全" },
  { "topic": "自动驾驶安全：AI的责任" },
  { "topic": "AI在电商反欺诈中的应用" },
  { "topic": "AI在企业反欺诈中的实践" },
  { "topic": "AI办公系统：安全与效率的平衡" },
  { "topic": "AI驱动安全体系重构" },
  { "topic": "安全运营自动化实践" },
  { "topic": "MCP在安全中的落地" },
  { "topic": "模型滥用检测机制" },
  { "topic": "从GPT到Agent：下一代AI交互范式的演进路径" },
  { "topic": "RAG系统设计最佳实践：从检索到生成的全链路优化" },
  { "topic": "LLMOps体系建设：模型生命周期管理实践" },
  { "topic": "AI客服从降本到增收的跃迁路径" },
  { "topic": "Agent驱动的企业自动化运营" },
  { "topic": "AIGC如何重塑内容产业生态" },
  { "topic": "医疗大模型的临床落地挑战" },
  { "topic": "AI Native应用的产品方法论" },
  { "topic": "LLM如何重构安全运营体系" },
  { "topic": "基于大模型的自动化渗透测试" },
  { "topic": "红蓝对抗的Agent化趋势" },
  { "topic": "下一代XDR：AI驱动的安全中枢" },
  { "topic": "隐私计算在大模型中的应用实践" },
  { "topic": "数据投毒攻击的检测与防御" },
  { "topic": "RAG系统的安全漏洞与防御策略" },
  { "topic": "多模态模型如何重构内容与交互" },
  { "topic": "长上下文 vs RAG：企业应用的最佳实践" },
  { "topic": "Agent平台化：从单体能力到系统能力" },
  { "topic": "合成数据在大模型训练中的应用" },
  { "topic": "如何防止模型被复制与滥用" },
  { "topic": "企业AI治理框架构建" },
  { "topic": "基于AI的身份风险识别" },
  { "topic": "AI驱动的终端威胁检测" },
  { "topic": "AI在供应链安全中的实践" },
  { "topic": "AI在反欺诈中的应用与对抗升级" },
  { "topic": "从大模型到智能体：AI系统形态的演进路径" },
  { "topic": "AI推理成本控制与性能优化" },
  { "topic": "AI在金融风控中的应用实践" },
  { "topic": "工业AI在制造业中的应用" },
  { "topic": "企业AI应用中的数据泄露风险" },
  { "topic": "AI系统的治理与责任界定" },
  { "topic": "数据治理如何影响模型安全" },
  { "topic": "隐私计算在AI训练中的应用实践" },
  { "topic": "大模型训练数据的可信性保障" },
  { "topic": "模型窃取与知识产权保护机制" },
  { "topic": "对抗攻击技术的演进趋势" },
  { "topic": "大模型越狱攻击的原理与防护" },
  { "topic": "Agent系统的攻击面与风险控制" },
  { "topic": "RAG系统的安全漏洞分析" },
  { "topic": "模型部署过程中的安全挑战" },
  { "topic": "AI供应链攻击路径" },
  { "topic": "AI推理环境的安全防护体系" },
  { "topic": "AI SOC从告警处理到自动决策" },
  { "topic": "威胁情报的自动化分析" },
  { "topic": "大模型驱动的威胁检测" },
  { "topic": "攻防博弈中的AI应用" },
  { "topic": "AI驱动的攻防对抗新范式" },
  { "topic": "安全大模型的能力边界" },
  { "topic": "AI生成内容的安全治理" },
  { "topic": "社会工程攻击的AI化趋势" },
  { "topic": "推理型模型的关键技术突破" },
  { "topic": "长上下文能力对企业应用的影响" }
]
